import _, { castArray, get, isNil, uniqueId } from 'lodash';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form';
import { notification } from 'antd';

export const createNewId = () => {
  return 'NEW' + Date.now();
};

export const isNewId = (id: string | number) => {
  return typeof id === 'string' && id.startsWith('NEW');
};

export const prepareId = (id: string | number) => {
  return isNewId(id) ? null : id;
};

export const indexBy = <D extends { [key: string]: any }, K extends keyof D>(
  array: Array<D>,
  key: K
): Record<string, number> => {
  return array.reduce((result, item, index) => {
    return {
      ...result,
      [item[key]]: index,
    };
  }, {});
};

export const shouldUpdateCompare =
  (key: string | string[]) => (objA: object, objB: object) => {
    return (
      castArray(key).find((k) => get(objA, k) !== get(objB, k)) !== undefined
    );
  };

export const getURLFile = (filename: string, url: string) => {
  const token = localStorage.getItem('token');
  const urlOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      'dev-stage': 'true',
    },
  };
  let fileURL;
  return fetch(url, urlOptions)
    .then((res) => res.blob())
    .then((blob) => {
      if (blob.type === 'text/html') return blob.text().then((res) => res);
      if (blob.type === 'application/pdf') {
        fileURL = window.URL.createObjectURL(blob);

        return fileURL;
      }
      return null as any;
    });
};

export const downloadBlobFile = (filename: string, url: string) => {
  const token = localStorage.getItem('token');
  const urlOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      'dev-stage': 'true',
    },
  };

  return fetch(url, urlOptions)
    .then((res) => res.blob())
    .then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.target = '_blank';
      fileLink.download = filename;
      fileLink.click();
    });
};

export const downloadJSONFile = (data: any, filename: string) => {
  const dataStr =
    'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data));
  const fileLink = document.createElement('a');
  fileLink.setAttribute('href', dataStr);
  fileLink.setAttribute('download', `${filename}.json`);
  fileLink.click();
};

export const toDatePickerDate = (date?: string) => {
  return date ? moment(date) : '';
};

export const dateToString = (date: any) => {
  if (date === '' || isNil(date)) {
    return '';
  } else {
    return typeof date === 'string' ? date : date.format('YYYY-MM-DD');
  }
};

export const generateId = () => uniqueId('generated-');

export const isGeneratedId = (id: any) =>
  typeof id === 'string' ? id.startsWith('generated-') : false;

export const prepareObjectForApiCall = (object: any) => {
  return Object.keys(object).reduce((result, key) => {
    var value: any = object[key];
    if (key === 'feesFormulaList') {
      value = value.priid;
    }

    if (key === 'feesformula') {
      value = value?.priid;
    }

    if (key === 'tpidbyuer') {
      value = value?.tpid;
    }
    if (key === 'tpparentcompanyid') {
      value = value.tpid;
    }

    return {
      ...result,
      [key]:
        value instanceof moment ? (value as any).format('YYYY-MM-DD') : value,
    };
  }, {});
};

export function unGroup<T>(object: Record<string, T[]>) {
  return Object.keys(object).reduce<T[]>((result, key) => {
    const value: any = object[key];
    if (Array.isArray(value)) {
      return [...result, ...value];
    } else {
      return result;
    }
  }, []);
}

export const customDataPrepareForApiCallSFS = (
  object: any,
  entity: any,
  entityid: any,
  objectreference: any,
  form: FormInstance
) => {

  if (form.getFieldValue('event') === 'TabEvAuthorizationSFS') {

    return {
      // authDetail: form.getFieldValue('authDetail'),
      tpid: form.getFieldValue('tpid'),
      creationdate: form.getFieldValue('creationdate'),
      useridcreation: form.getFieldValue('useridcreation'),
      startdate: form.getFieldValue('startdate'),
      enddate: form.getFieldValue('enddate'),
      authstatus: form.getFieldValue('authstatus'),
      authstatusdate: form.getFieldValue('authstatusdate'),
      authamount: form.getFieldValue('authamount'),
      proctaskid: form.getFieldValue('proctaskid'),
      authbookedamount: form.getFieldValue('authbookedamount'),
      authusedamount: form.getFieldValue('authusedamount'),
      authavailableamount: form.getFieldValue('authavailableamount'),
      authcalculatedamount: form.getFieldValue('authcalculatedamount'),
      scoid: form.getFieldValue('scoid'),
      authcomment: form.getFieldValue('authcomment'),
      authtolerance: form.getFieldValue('authtolerance') ?? 0,
      authusedamountalert: form.getFieldValue('authusedamountalert') ?? 0,
      authflagtransfer: form.getFieldValue('authflagtransfer') ?? false,
      prcode: form.getFieldValue('prcode'),
      offerid: form.getFieldValue('offerid'),
      flagretailer: form.getFieldValue('flagretailer') ?? false,
      flagtolerance: form.getFieldValue('flagtolerance') ?? false,
      creditcontrol: form.getFieldValue('creditcontrol') ?? '',
      authtype: 'LIMIT',
      currcode: localStorage.getItem('currcode') ?? '',
      flagexcludpermeabilitypm: form.getFieldValue('flagexcludpermeabilitypm') ?? false,
      mode: form.getFieldValue('flagretailer') ?? '',
    };
  }
  else if (form.getFieldValue('event') === 'tabAddress') {

    console.log('form tabTPChangeAddress', form.getFieldsValue(), "event", form.getFieldValue('event'))
    return {
      tpid: form.getFieldValue('tpid'),
      adrtype: form.getFieldValue('adrtype'),
      tpmainadrstreet1: form.getFieldValue('tpmainadrstreet1'),
      tpmainadrstreet2: form.getFieldValue('tpmainadrstreet2'),
      tpmainadrstreet3: form.getFieldValue('tpmainadrstreet3'),
      tpmainadrzipcodeTP: form.getFieldValue('tpmainadrzipcodeTP'),
      tpmainadrcityTP: form.getFieldValue('tpmainadrcityTP'),
      tpmainadrcountryTP: form.getFieldValue('tpmainadrcountryTP'),



    };
  } else if (form.getFieldValue('event') === 'TabUpdateAuthAmount') {

    return {
      ...form.getFieldsValue(),
      authdetailid: form.getFieldValue('authdetailid'),
      authdetailamount: form.getFieldValue('authdetailamount'),
      authid: form.getFieldValue('authid'),
    };
  } else if (form.getFieldValue('event') === 'TabUpdateMPEAAmount') {

    return {
      ...form.getFieldsValue(),
      authid: form.getFieldValue('authid'),
      authcalculatedamount: form.getFieldValue('authcalculatedamount'),
    };
  } else if (form.getFieldValue('event') === 'TabUpdateStatusAuth') {
    return {
      ...form.getFieldsValue(),
      authid: form.getFieldValue('authid'),
      authstatus: form.getFieldValue('authstatus'),
      enddate: moment(form.getFieldValue('enddate')).format('YYYY-MM-DD'),
    };
  } else if (form.getFieldValue('event') === 'TabActivatePermeability') {
    return {
      ...form.getFieldsValue(),
      authid: form.getFieldValue('authid'),
      flagexcludpermeabilitypm: form.getFieldValue('flagexcludpermeabilitypm'),
    };
  } else if (form.getFieldValue('event') === 'TabDeleteActivity') {
    return {
      ...form.getFieldsValue(),
      authid: form.getFieldValue('authid'),
    };
  } else if (form.getFieldValue('event') === 'TabUpdateCreditControl') {
    return {
      ...form.getFieldsValue(),
      authid: form.getFieldValue('authid'),
      creditcontrol: form.getFieldValue('creditcontrol'),
    };
  } else if (form.getFieldValue('event') === 'TabOverActivity') {
    return {
      ...form.getFieldsValue(),
      authid: form.getFieldValue('authid'),
      authdetailid: form.getFieldValue('authdetailid'),
      flagtolerance: form.getFieldValue('flagtolerance'),
      tolerancetype: form.getFieldValue('tolerancetype'),
      tolerancerate: form.getFieldValue('tolerancerate'),
      toleranceamount: form.getFieldValue('toleranceamount'),
      startdate: form.getFieldValue('startdate').format('YYYY-MM-DD'),
      enddate: moment(form.getFieldValue('enddate')).format('YYYY-MM-DD'),
      comment: form.getFieldValue('comment'),
    };
  }

  else if (form.getFieldValue('event') === 'TabIntraBrand') {
    return {
      ...form.getFieldsValue(),
      authReq: form.getFieldValue('authList'),
      tptype: form.getFieldValue('tptype'),
      authbrand: form.getFieldValue('authbrand'),
    };
  }

  else if (form.getFieldValue('event') === 'TabDeleteSiloInter') {
    return {
      ...form.getFieldsValue(),
      siloid: form.getFieldValue('siloid'),
    };
  } else if (form.getFieldValue('event') === 'tabCreateSiloInter') {
    return {
      ...form.getFieldsValue(),
      silolabel: form.getFieldValue('silolabel'),
      prcode: form.getFieldValue('prcode'),
      siloList: form.getFieldValue('silointraList')?.filter((silo: any) => silo.siloselected)?.map((e: any) => e.siloid),
    };
  }


  else if (form.getFieldValue('event') === 'tabUpdateSiloInter') {
    return {
      ...form.getFieldsValue(),
      silolabel: form.getFieldValue('silolabel'),
      siloid: form.getFieldValue('siloid'),
      prcode: form.getFieldValue('prcode'),
      siloList: form.getFieldValue('silointraList')?.filter((silo: any) => silo.siloselected)?.map((e: any) => e.siloid),

    };
  }
  else if (form.getFieldValue('event') === 'tabschedulepayment') {
    return {
      ...form.getFieldsValue(),
      effectdate: moment(form.getFieldValue('effectdate')).format('YYYY-MM-DD'),
      bkaccount: form.getFieldValue('bkaccount'),
      comment: form.getFieldValue('comment'),
      reimbursedamount: form.getFieldValue('reimbursedamount'),
      motif: form.getFieldValue('motif'),
      mode: "SIMUL",
      targetStatus: form.getFieldValue('targetStatus'),
    };
  }

  else if (form.getFieldValue('event') === 'tabSfsAcceptpay') {
    return {
      ...form.getFieldsValue(),
      effectdate: moment(form.getFieldValue('effectdate')).format('YYYY-MM-DD'),
      bkaccount: form.getFieldValue('bkaccount'),
      comment: form.getFieldValue('comment'),
      reimbursedamount: form.getFieldValue('reimbursedamount'),
      motif: form.getFieldValue('motif'),
      mode: "REAL",
      targetStatus: form.getFieldValue('targetStatus'),
      modid: form.getFieldValue('modid')
    };
  }


  else if (form.getFieldValue('event') === 'tabconvertcontract') {
    return {
      ...form.getFieldsValue(),
      effectDate: moment(form.getFieldValue('effectdate')).format('YYYY-MM-DD'),
      mode: "SIMUL",
      targetproductcode: form.getFieldValue('targetproductcode'),
    };
  }

  else if (form.getFieldValue('event') === 'tabAcceptconversion') {
    return {
      ...form.getFieldsValue(),
      mode: "REAL",
      modid: form.getFieldValue('modid'),
      effectDate: moment(form.getFieldValue('effectdate')).format('YYYY-MM-DD'),
    };
  }



  else {
    return {
      objectreference: objectreference,
    };
  }
};
export const setValueByNamePath = (
  form: FormInstance,
  namePath: (string | number)[],
  value: string | number | null | object | boolean
) => {
  const [valuesKey, index, fieldName] = namePath;
  const values = form.getFieldValue(valuesKey);
  values[index][fieldName] = value;
  form.setFieldsValue({ valuesKey: values });
};

export const objectParValueToString = (parvalue: any) => {
  if (typeof parvalue === 'object') {
    return parvalue?.value;
  }
  return parvalue;
};

export const objectLabelToString = (parvalue: any) => {
  if (typeof parvalue === 'object') {
    return parvalue?.label;
  }
  return parvalue;
};

export const NormalizeOnlyAlph = (
  value: string,
  prevvalue?: any,
  allvalues?: any,
  max: number = 10
) => {
  if (/^[a-zA-Z]+$/.test(value) && value.length <= max)
    return value.toUpperCase();
  else if (/^[a-zA-Z]+$/.test(value.slice(0, value.length - 1)))
    return value.slice(0, value.length - 1);
  else return '';
};

export const NormalizeAlphAndNum = (
  value: string,
  prevvalue?: any,
  allvalues?: any,
  max: number = 10
) => {
  if (/^[a-zA-Z0-9]+$/.test(value) && value.length <= max)
    return value.toUpperCase();
  else if (/^[a-zA-Z0-9]+$/.test(value.slice(0, value.length - 1)))
    return value.slice(0, value.length - 1);
  else return '';
};
export const OnlyIntegerNumber = (
  value: string,
  prevvalue?: any,
  allvalues?: any,
  max: number = 13
) => {
  if (/^[0-9]+$/.test(value) && value.length <= max) return value;
  else if (/^[0-9]+$/.test(value.slice(0, value.length - 1)))
    return value.slice(0, value.length - 1);
  else return '';
};

export const ibanValidator = (iban: string) => {
  let rib = iban?.substring(iban?.length - 24);
  let result =
    97 -
    (Number(
      String(
        Number(String(Number(rib?.slice(0, 8)) % 97) + rib?.slice(8, 16)) % 97
      ) +
      rib?.slice(16, 22) +
      '00'
    ) %
      97);

  let isValidate = result === Number(rib?.slice(22, 24));

  return isValidate;
};
export const calculateDate = (
  prefinStepList: any[],
  _lctesstartdate?: string
) => {
  // Ensure a valid initial start date
  let lctesstartdate = _lctesstartdate || moment().format('YYYY-MM-DD');
  let lctesenddate = moment(lctesstartdate)
    .add(prefinStepList[0]?.ctesduration || 0, 'days')
    .format('YYYY-MM-DD');

  const newData = _.orderBy(prefinStepList ?? [], 'ctesorder', 'asc').map(
    (step, index) => {
      if (index > 0) {
        // The next step's start date should be the day after the previous step's end date
        lctesstartdate = moment(lctesenddate)
          .add(1, 'day')
          .format('YYYY-MM-DD');

        // Calculate the end date based on the start date and the duration of the step
        lctesenddate = moment(lctesstartdate)
          .add(step.ctesduration, 'days')
          .format('YYYY-MM-DD');
      }

      return {
        ...step,
        ctesstartdate: lctesstartdate,
        ctesenddate: lctesenddate,
        enddate: lctesenddate,
      };
    }
  );

  return newData;
};
//this function disables the past dates in the datepicker, from a certain date
export const isBeforeDate = (selectedDate: any, date: any) => {
  if (selectedDate == null) {
    return null;
  }

  return (
    date != null &&
    selectedDate.isBefore(date) &&
    !selectedDate.isSame(date, 'day')
  );
};

export const isWithinDateRange = (
  selectedDate: any,
  inferiorLimit: any,
  superiorLimit: any
) => {
  if (selectedDate == null) {
    return null;
  }

  return (
    inferiorLimit != null && superiorLimit != null && (
      (inferiorLimit != null && selectedDate.isBefore(inferiorLimit)) ||
      (superiorLimit != null && selectedDate.isAfter(superiorLimit)))
  );
};
